import { _, helpers, ts } from '_core';

import { DraftParams } from './types';
import { getBucketsTitle } from '../../common/utils/get-name';
import { prepareBarChartBucketedNames, prepareBarChartCountNames } from '../../common/utils/get-series-name';

export const prepareBucketedData = (
  widgetData: ts.types.widgets.NestedBarWidgetData,
  bucketType: ts.types.widgets.common.BucketValue['type'],
  bucketValue: ts.types.widgets.common.BucketValue['value'],
  histories: ts.enums.HISTORY_ENUM_EXTENDED[],
  resources: ts.StoreState['resources']
): ts.types.widgets.NestedBarWidgetData => {
  const formattedData = {
    ...widgetData,
    data: prepareBarChartBucketedNames(widgetData.data, bucketType, bucketValue, resources),
    count: prepareBarChartCountNames(widgetData.count, bucketType, bucketValue, resources),
  };

  const count = _.pick(formattedData.count, histories);
  const data = _.filter(formattedData.data, (item) => histories.includes((item as any).category));

  return { data, count };
};

export const validate = (params: DraftParams) => {
  const rhErrors = helpers.validations.validSelectedReturnHorizon(params?.return_horizon);
  if (!_.isEmpty(rhErrors)) return rhErrors;
  if (_.isEmpty(params.histories)) return ['Histories is a required field.'];
  if (!helpers.validations.validBuckets(params.buckets)) return ['Buckets are invalid.'];
  return [];
};

export const getName = (
  params: DraftParams,
  _context: ts.types.signal.SignalAnalysisContext,
  resources: ts.StoreState['resources']
) => {
  let widgetTitle = 'Annualized Returns by Bucket';

  if (params.statistics_type === 'risk') widgetTitle = 'Annualized Risk by Bucket';
  else if (params.statistics_type === 'adjusted') widgetTitle = 'Annualized Risk Adjusted Returns by Bucket';

  const init = getBucketsTitle(params.buckets, widgetTitle, resources);
  return `${init} for ${helpers.returnHorizon.getLabel(params?.return_horizon)}`;
};
